var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('account-summary')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Cuenta de usuario")])])])
}]

export { render, staticRenderFns }